document.addEventListener('DOMContentLoaded', () => {
  const positionKey = 'heritage-chat-position';
  const chatPrompts = [
    { icon: '👞', label: 'Find my perfect RW!' },
    { icon: '🧔', label: 'Talk to RWH expert' },
    { icon: '🧴', label: 'Leather care assistant?' },
    { icon: '📏', label: 'I need sizing help!' },
    { icon: '🎁', label: "I'm buying a gift!" },
    { icon: '❤️', label: 'I already own Red Wings!' },
    { icon: '🪡', label: 'Goodyear welt stitching' }
  ];

  document.querySelectorAll('.heritage-chat-fallback, #heritage-chat-launcher').forEach((button) => button.remove());

  const constrain = (button, left, top) => ({
    left: Math.min(Math.max(8, left), window.innerWidth - button.offsetWidth - 8),
    top: Math.min(Math.max(8, top), window.innerHeight - button.offsetHeight - 8)
  });

  const positionButton = (button, position) => {
    if (!position || !Number.isFinite(position.left) || !Number.isFinite(position.top)) return;
    const next = constrain(button, position.left, position.top);
    button.style.setProperty('position', 'fixed', 'important');
    button.style.setProperty('right', 'auto', 'important');
    button.style.setProperty('bottom', 'auto', 'important');
    button.style.setProperty('left', `${next.left}px`, 'important');
    button.style.setProperty('top', `${next.top}px`, 'important');
  };

  const styleButton = (button) => {
    button.style.setProperty('display', 'grid', 'important');
    button.style.setProperty('color', '#fff', 'important');
    button.style.setProperty('background', '#0d465a', 'important');
    button.style.setProperty('border-color', '#0d465a', 'important');
    button.style.setProperty('cursor', 'grab', 'important');
    button.style.setProperty('touch-action', 'none', 'important');
    button.style.setProperty('user-select', 'none', 'important');
    button.setAttribute('aria-label', 'Live chat. Drag to reposition.');
  };

  const enhanceButton = (button) => {
    styleButton(button);

    if (!button.querySelector('.heritage-chat-emoji')) {
      const emoji = document.createElement('span');
      emoji.className = 'heritage-chat-emoji';
      emoji.setAttribute('aria-hidden', 'true');
      emoji.textContent = chatPrompts[0].icon;
      button.prepend(emoji);
    }

    const currentLabel = button.querySelector('.activator__label, .chat-title, [data-spec="button-text"]');
    if (currentLabel) {
      currentLabel.style.setProperty('color', '#fff', 'important');
      currentLabel.style.setProperty('font-weight', '700', 'important');
      currentLabel.style.setProperty('font-size', '10px', 'important');
    }

    if (!button.heritageEmojiTimer) {
      button.heritageEmojiIndex = 0;
      const initialLabel = button.querySelector('.activator__label, .chat-title, [data-spec="button-text"]');
      if (initialLabel) initialLabel.textContent = chatPrompts[0].label;
      button.heritageEmojiTimer = window.setInterval(() => {
        if (!button.isConnected) {
          window.clearInterval(button.heritageEmojiTimer);
          button.heritageEmojiTimer = null;
          return;
        }
        button.heritageEmojiIndex = (button.heritageEmojiIndex + 1) % chatPrompts.length;
        const prompt = chatPrompts[button.heritageEmojiIndex];
        const emoji = button.querySelector('.heritage-chat-emoji');
        const label = button.querySelector('.activator__label, .chat-title, [data-spec="button-text"]');
        if (emoji) emoji.textContent = prompt.icon;
        if (label) label.textContent = prompt.label;
      }, 4000);
    }

    if (button.dataset.heritageDraggable === 'true') return;
    button.dataset.heritageDraggable = 'true';

    try {
      positionButton(button, JSON.parse(localStorage.getItem(positionKey)));
    } catch {
      // Use Shopify Inbox's default position.
    }

    let drag = null;
    let suppressClick = false;

    button.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      const rect = button.getBoundingClientRect();
      drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startLeft: rect.left,
        startTop: rect.top,
        moved: false
      };
    });

    window.addEventListener('pointermove', (event) => {
      if (!drag || drag.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - drag.startX;
      const deltaY = event.clientY - drag.startY;
      if (!drag.moved && Math.hypot(deltaX, deltaY) < 5) return;
      event.preventDefault();
      drag.moved = true;
      suppressClick = true;
      button.classList.add('heritage-is-dragging');
      button.style.setProperty('cursor', 'grabbing', 'important');
      positionButton(button, {
        left: drag.startLeft + deltaX,
        top: drag.startTop + deltaY
      });
    }, { passive: false });

    const finishDrag = (event) => {
      if (!drag || drag.pointerId !== event.pointerId) return;
      const moved = drag.moved;
      drag = null;
      button.classList.remove('heritage-is-dragging');
      button.style.setProperty('cursor', 'grab', 'important');
      if (!moved) return;
      const rect = button.getBoundingClientRect();
      try {
        localStorage.setItem(positionKey, JSON.stringify({ left: rect.left, top: rect.top }));
      } catch {
        // Position persistence is optional.
      }
    };

    window.addEventListener('pointerup', finishDrag);
    window.addEventListener('pointercancel', finishDrag);
    button.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);

    window.addEventListener('resize', () => {
      if (!button.isConnected || !button.style.left) return;
      const rect = button.getBoundingClientRect();
      positionButton(button, { left: rect.left, top: rect.top });
    }, { passive: true });
  };

  const observedRoots = new WeakSet();
  const rootObservers = [];

  const enhance = () => {
    const roots = [...document.querySelectorAll('shopify-chat, inbox-online-store-chat')]
      .map((chat) => chat.shadowRoot)
      .filter(Boolean);
    if (!roots.length) return false;

    const activators = [];

    roots.forEach((root) => {
      if (!root.querySelector('#heritage-chat-style')) {
        const style = document.createElement('style');
        style.id = 'heritage-chat-style';
        style.textContent = `
        .activator,
        .chat-toggle,
        .activator:hover,
        .chat-toggle:hover,
        .activator:focus,
        .chat-toggle:focus,
        .activator:focus-visible,
        .chat-toggle:focus-visible,
        .activator:active,
        .chat-toggle:active {
          color: #fff !important;
          background: #0d465a !important;
          border-color: #0d465a !important;
        }
        .activator .activator__label,
        .chat-toggle .chat-title,
        .chat-toggle [data-spec="button-text"],
        .activator span {
          color: #fff !important;
          font-weight: 700 !important;
          font-size: 10px !important;
        }
        .heritage-chat-emoji {
          display: inline-block;
          margin-right: 8px;
          font-size: 20px;
          line-height: 1;
          transform-origin: 70% 70%;
          animation: heritage-chat-wave 1.4s ease-in-out infinite;
        }
        @keyframes heritage-chat-wave {
          0%, 60%, 100% { transform: rotate(0); }
          10% { transform: rotate(14deg); }
          20% { transform: rotate(-8deg); }
          30% { transform: rotate(14deg); }
          40% { transform: rotate(-4deg); }
          50% { transform: rotate(10deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .heritage-chat-emoji { animation: none; }
        }
      `;
        root.appendChild(style);
      }

      activators.push(...[...root.querySelectorAll('button')].filter((button) => {
        const label = button.getAttribute('aria-label') || '';
        const text = button.textContent || '';
        return button.matches('.activator, .chat-toggle, [part="activator"], [data-spec="toggle-button"]')
          || /live chat/i.test(`${label} ${text}`);
      }));

      if (!observedRoots.has(root)) {
        observedRoots.add(root);
        const observer = new MutationObserver(enhance);
        observer.observe(root, { childList: true, subtree: true });
        rootObservers.push(observer);
      }
    });

    if (!activators.length) return false;

    const visibleActivators = activators.filter((button) => button.getClientRects().length);
    const primary = visibleActivators[0] || activators[0];
    enhanceButton(primary);
    activators.filter((button) => button !== primary).forEach((duplicate) => {
      duplicate.style.setProperty('display', 'none', 'important');
    });

    return true;
  };

  new MutationObserver(enhance).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(enhance, 750);
  enhance();
});
